import AxiosConfig from '@/config/axios-config'

export const DestaqueAPI = {

  listar (pagina, tipo) {
    return AxiosConfig.secureJalekoAPI().get('/admin/destaques',
      {
        params: {
          page: pagina,
          tipo: tipo
        }
      }).then(response => response.data)
  },

  deletar (destaque) {
    return AxiosConfig.secureJalekoAPI().delete(`/admin/destaques/${destaque.id}`, destaque).then(response => response.data)
  },

  salvar (destaque) {
    let formData = new FormData()

    for (var key in destaque) {
      formData.append(key, destaque[key])
    }

    return AxiosConfig.secureJalekoAPI().post('/admin/destaques', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  },

  atualizar (destaque) {
    let formData = new FormData()

    for (var key in destaque) {
      formData.append(key, destaque[key])
    }
    return AxiosConfig.secureJalekoAPI().post(`/admin/destaques/${destaque.id}?_method=PUT`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  }

}

export default DestaqueAPI
